(function (){
    'use strict';

    angular
        .module('auth')
        .config(AuthRouteConfig);

    AuthRouteConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
    
    /* @ngInject */
    function AuthRouteConfig ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('auth', {
                abstract: true,
                url: '/auth',
                views: {
                    'top-view': {
                        template: '<div ui-view="top-view"></div>'
                    }
                },
            })
            .state('auth.login', {
                url: '/login',
                views: {
                    'top-view': {
                        templateUrl: 'templates/auth/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'login'
                    }
                }
            })
            .state('auth.logout', {
                url: '/logout',
                views: {
                    'top-view' : {
                        controller: 'LogoutController',
                        controllerAs: 'logout'
                    }
                }
            })    
            .state('auth.partners', {
                disableCache: true,
                abstract: true,
                url: '/partners',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
                views: {
                    'top-view': {
                        template: '<div ui-view="top-view"></div>'
                    }
                },
            })
            .state('auth.partners.login', {
                url: '/login',
                views: {
                    'top-view': {
                        templateUrl: 'templates/auth/partners/login/login.html',
                        controller: 'PartnerLoginController',
                        controllerAs: 'partnerLogin'
                    }
                }
            })
            .state('auth.partners.logout', {
                url: '/logout',
                views: {
                    'top-view' : {
                        controller: 'PartnersLogoutController',
                        controllerAs: 'partnersLogout'
                    }
                }
            })
            .state('auth.platformRental', {
                disableCache: true,
                abstract: true,
                url: '/platform-rental',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                },
                views: {
                    'top-view': {
                        template: '<div ui-view="top-view"></div>'
                    }
                },
            })
            .state('auth.platformRental.login', {
                url: '/login',
                views: {
                    'top-view': {
                        templateUrl: 'templates/platform-rental/login/login.html',
                        controller: 'PlatformRentalLoginController',
                        controllerAs: 'platformRentalLogin'
                    }
                }
            })
            .state('auth.platformRental.logout', {
                url: '/logout',
                views: {
                    'top-view' : {
                        controller: 'PlatformRentalLogoutController',
                        controllerAs: 'platformRentalLogout'
                    }
                }
            });
            $urlRouterProvider.otherwise("/auth/login");
    }
})();